import { Injectable } from '@angular/core';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import { MediumTypeEnum } from '../enums/medium-type.enum';
import { ProductsEnum } from '../enums/products-enum';
import { BdbRequestService } from './bdb-request.service';
import { environment } from '../../../environments/environment';
import { SandboxService } from './sandbox/sandbox.service';
import { HeadersRequestEnum } from '../enums/headers-request.enum';


@Injectable()
export class BdbBffService {
    constructor(
        private readonly bdbSessionStorageService: BdbSessionStrgService,
        private readonly bdbRquestService: BdbRequestService,
        private readonly sandbox: SandboxService
    ) {}

    async requestPostBff(bodyRequest: any, nameConfig: string, useCustomHeaders = false) {
        let newHeaders;
        const url = environment.bffAuthMngrEnpoint + '/loadConfig';
        const documentNumber = this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER);
        const documentType = this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE) === 'C'
            ? 'CC' : this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE);
        if (useCustomHeaders) {
            newHeaders = await this.getHeadersToBff();
        } else {
            newHeaders = this.bdbRquestService.getStandardizedHeadersForSandboxv3(documentType, documentNumber);
            newHeaders['X-Name'] = nameConfig;
            newHeaders['X-Product'] = nameConfig;
        }

        return this.sandbox.request('POST', {
            url,
            body: bodyRequest,
            headers: newHeaders,
            uuid: newHeaders['X-RqUID'],
            unencryptedHeaders: {
                [HeadersRequestEnum.X_CHANNEL]: this.bdbSessionStorageService.get(SessionStorageKeysEnum.CHANNEL) || 'Oficina',
            }
        });
    }

    public async getParamsToBff(mediumType: number, site: string) {
        const profileName = this.getKeyforMediumType(mediumType).toLowerCase();
        const appConfig = ProductsEnum[site].appConfig ? ProductsEnum[site].appConfig : null;
        const body = {
            applicationName: 'assisted',
            profileName
        };
        if (!!profileName && !!appConfig) {
            const values = await this.requestPostBff(body, appConfig);
            for (const value in values.body.data) {
                this.bdbSessionStorageService.save(value, values.body.data[value]);
            }
        }
    }

    public async getParamsToInitialLoad(profileName: string) {
        const body = {
            applicationName: 'assisted',
            profileName
        };
        return this.requestPostBff(body, null, true).then((response) => {
            return response.body.data;
        }).catch((error) => {
            console.error('Error getting params to BFF', error);
            return null;
        });
    }

    getKeyforMediumType(mediumType: number): string {
        for (const key in MediumTypeEnum) {
            if (parseInt(MediumTypeEnum[key], 10) === mediumType) {
                return key;
            }
        }
        return null;
    }

    private async getHeadersToBff() {
        return {
            'X-Channel': 'Oficina',
            'X-CustIdentType': 'CC',
            'X-CustIdentNum': '999999999',
            'X-IPAddr': '127.0.0.1',
            'X-CompanyId': '001',
            'X-Product': 'asistido',
            'X-Name': 'seguridad',
            'X-RqUID': '5d4bb81b-6ccb-4ce5-8631-0b30a7a4ff49',
            'X-User-Agent': navigator.userAgent
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/bdb-bff.service.ts